import * as React from 'react';
import {inject, observer} from 'mobx-react';
import {UIView} from '@uirouter/react';
import {Store} from '../lib/App/Store';

interface PageProps {
  store: Store;
}

@inject('store')
@observer
export class Page extends React.Component<PageProps, {}> {
  private rootNodeHandler: HTMLElement = document.getElementsByTagName('html')[0];

  componentDidMount() {
    this.resizeListener();
    window.onhashchange = this.resizeListener;
    window.addEventListener('resize', this.resizeListener);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeListener);
    window.onhashchange = null;
  }

  private resizeListener = () => {
    if (document.documentElement) {
      const vh = window.innerHeight * 0.01;
      this.rootNodeHandler.style.setProperty('--vh', `${vh}px`);
    }
  };

  render() {
    return (
      <div className='main-page-container'>
        <UIView />
      </div>
    );
  }
}
